import React from "react";
import "../App.css";
import { Link as ScrollLink } from "react-scroll";
import Untitled_design1 from "./Assets/hthomepic2.gif";
import Untitled from "./Assets/heartin tech.png";

function Home() {
  return (
    <div className="home">
      <div className="container">
        <div className="content">
          <div className="text-block">
            <h1 className="headline">
              Experience
              <br />
              Excellence
              <br />
              With us.
            </h1>
            <ScrollLink to="contact" smooth={true} duration={500} offset={-50}>
              <button className="cta-button">
                SOLUTION EXPERT FOR YOUR BUSINESS
              </button>
            </ScrollLink>
          </div>

          <div className="image-block">
            <img src={Untitled_design1} alt="Teamwork" className="slide-up" />
          </div>

          <div className="image-block">
            <img src={Untitled} alt="Logo" className="slides-up" />
          </div>
        </div>
      </div>
    </div>
  );
}

export default Home;
